import { Skeleton } from '@epilot/concorde-elements'

import classes from '../../Skeleton.module.scss'

export const AuthControlSkeleton = () => {
  return (
    <div className={classes.root}>
      <div className={classes.gridRow}>
        <Skeleton style={{ marginRight: '20%' }}>
          <span>Enter your e-mail to log-in or create an account.</span>
        </Skeleton>
        <Skeleton className={classes.inputSize}>&nbsp;</Skeleton>
        <div
          className={classes.flexRow}
          style={{
            justifyContent: 'end',
            flexDirection: 'row-reverse'
          }}
        >
          <Skeleton className={classes.button} style={{ width: 'unset' }}>
            <span>Continue</span>
          </Skeleton>
          <Skeleton style={{ width: '80px', alignSelf: 'center' }}>
            <span>Skip</span>
          </Skeleton>
        </div>
      </div>
    </div>
  )
}
